{
  "version": 1,
  "asset_id": "3845682e-786c-4f34-b81c-2a070837fd2e",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/3845682e-786c-4f34-b81c-2a070837fd2e/str-essentials-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/3845682e-786c-4f34-b81c-2a070837fd2e/str-essentials-placeholder.jpg",
  "original_filename": "str-essentials-placeholder.jpg",
  "size": 250360,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T15:29:33Z"
}
